import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { projectFirestore } from "../firebase-config/config";

const OrderReceiptView = () => {
  const { orderId } = useParams();
  const [receiptUrl, setReceiptUrl] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchOrder = async () => {
      setLoading(true);
      setError(null);
      try {
        const orderDoc = await projectFirestore.collection("orders").doc(orderId).get();
        if (!orderDoc.exists) {
          setError("Order not found.");
          setLoading(false);
          return;
        }
        const orderData = orderDoc.data();
        if (orderData && orderData.receiptUrl) {
          setReceiptUrl(orderData.receiptUrl);
        } else {
          setError("Receipt not available.");
        }
      } catch (err) {
        setError("Failed to load receipt: " + (err.message || err));
      } finally {
        setLoading(false);
      }
    };
    fetchOrder();
  }, [orderId]);

  return (
    <div style={{ width: "100vw", minHeight: "100vh", background: "#f7f7f7" }}>
      <div style={{ padding: 20, display: "flex", alignItems: "center", gap: 20 }}>
        <h2 style={{ margin: 0 }}>Order Receipt for #{orderId}</h2>
        {/* {receiptUrl && (
          <a href={receiptUrl} download={`OrderReceipt_${orderId}.pdf`} style={{ textDecoration: "none", color: "#fff", background: "#1a73e8", padding: "8px 16px", borderRadius: 5, fontWeight: 500 }}>Download PDF</a>
        )} */}
      </div>
      {loading && <div style={{ textAlign: "center", marginTop: 50, fontSize: 20 }}>Loading receipt…</div>}
      {error && <div style={{ textAlign: "center", color: "#e00", marginTop: 60, fontWeight: 500 }}>{error}</div>}
      {receiptUrl && (
        <iframe
          src={receiptUrl}
          title={`Order Receipt ${orderId}`}
          style={{
            display: "block",
            width: "calc(100vw - 32px)",
            height: "86vh",
            margin: 16,
            background: "#fff",
            border: "1px solid #ccc",
            borderRadius: "10px"
          }}
        />
      )}
    </div>
  );
};

export default OrderReceiptView;
